
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { businessPartnerOperations, businessPartnerSelectors } from "./state";
import FormTemplate from '../../components/FormTemplate';
import ModuleHeader from '../../components/ModuleHeader';
import { BUSINESS_PARTNER } from "./routes";
import { ERROR, MODE_EDIT, MODE_ADD, EMPTY_STRING, DEFAULT_ID, SUCCESS, EMPTY_COUNT, MAX_INT, KANA_NO, KANA_YES } from '../../../utils/constants'
import { ERROR_SUPPLIER_NOT_EXIST, ERROR_SUPPLIER_RETRIEVE, CONFIRMATION_DELETE, ERROR_BP_CREATE, ERROR_BP_UPDATE, ERROR_BP_DELETE } from '../../../utils/messages'
import ErrorAlert from '../../components/ErrorAlert';
import Confirmation from '../../components/Confirmation';
import ConfirmationMail from '../../components/ConfirmationMail';

class ViewBusinessPartner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            promptDelete:false,
            invalidShop:false,
            copy: this.props.location.state && this.props.location.state.copy,
            businessPartnerCode: this.props.credentials.riyo_kigyo_id,
            updUserCode: this.props.credentials.user_cd,
            updUserType: this.props.credentials.authorities.authority,
            userCode: this.props.match.params.id,
            loginId: EMPTY_STRING,
            password: EMPTY_STRING,
            branchNumber: EMPTY_STRING,
            mainNumber: EMPTY_STRING,
            businessPartnerName: EMPTY_STRING,
            businessPartnerKana: EMPTY_STRING,
            email: EMPTY_STRING,
            tel: EMPTY_STRING,
            priceDisplay: EMPTY_STRING,
            forecastValue: EMPTY_STRING,
            sendMail: false,
            openModal: false,
            prevLoginId: EMPTY_STRING,
            error: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        let id = this.props.match.params.id;
        let bpCode = this.props.credentials.riyo_kigyo_id;

        if (undefined === id) {
            this.setState({ mode: MODE_ADD });
        } else {
            if (!this.state.copy) {
                this.setState({ mode: MODE_EDIT})
            }
            this.props.view({ businessPartnerCode: bpCode, userCode: id })
                .then((result) => {
                    let businessPartner = result.data
                    if (null === businessPartner) {
                        this.setState({ error: [ERROR_SUPPLIER_NOT_EXIST], invalidShop: true });
                    } else {
                        this.setState({
                            businessPartnerName: businessPartner.businessPartnerName,
                            businessPartnerKana: businessPartner.businessPartnerKana,
                            password: businessPartner.password,
                            email: businessPartner.email,
                            tel: businessPartner.tel,
                            forecastValue: businessPartner.priceDisplay.toString(),
                        });

                        if (!this.state.copy) {
                            this.setState({
                                businessPartnerId: id,
                                businessPartnerCode: businessPartner.businessPartnerCode,
                                branchNumber: businessPartner.branchNumber,
                                mainNumber: businessPartner.mainNumber,
                                loginId: businessPartner.loginId,
                                prevLoginId: businessPartner.loginId
                            });
                            if (DEFAULT_ID === id) {
                                this.setState({ default: true });
                            }
                        }
                    }
                })
                .catch(() => {
                    this.setState({ error: [ERROR_SUPPLIER_RETRIEVE], invalidShop: true });
                });
        }
    }

    handleInputChange = (event) => {
        let numberField = ("mainNumber" === event.target.name || "branchNumber" === event.target.name);
        if (!numberField) {
            this.setState({ [event.target.name]: event.target.value });
        }else{
            if((Number(event.target.value) && MAX_INT > event.target.value) || EMPTY_COUNT === Number(event.target.value)){
                this.setState({ [event.target.name]: event.target.value.trim() });
            }
        }

    }

    handleSubmit = () => {
        let errorList = businessPartnerSelectors.validate(this.state);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList });
        } else {
            this.setState({ error: [], sendMail: false });

            if (MODE_EDIT === this.state.mode) {
                let businessPartner = this.setBusinessPartnerModel();
                businessPartner.userCode = this.props.match.params.id;
                this.props.editBusinessPartner(businessPartner).then((result) => {
                    this.showError(result)
                }).catch(()=>this.setState({ error: [ERROR_BP_UPDATE] }));
            } else {
                this.props.checkLoginIdExists({
                    businessPartnerCode: this.state.businessPartnerCode,
                    loginId: this.state.loginId,
                    mainNumber: this.state.mainNumber,
                    branchNumber: this.state.branchNumber
                }).then((result) => {
                    if (SUCCESS === result.status) {
                        this.openModal();
                    } else {
                        this.setState({ error: result.messageList });
                    }
                }).catch(()=>this.setState({ error: [ERROR_BP_CREATE] }));


            }
        }
    }

    setBusinessPartnerModel = () => {
        return {
            businessPartnerCode: this.props.credentials.riyo_kigyo_id,
            updUserCode: this.props.credentials.user_cd,
            updUserType: this.props.credentials.authorities.authority,
            loginId: this.state.loginId,
            password: this.state.password,
            branchNumber: this.state.branchNumber,
            mainNumber: this.state.mainNumber,
            businessPartnerName: this.state.businessPartnerName,
            businessPartnerKana: this.state.businessPartnerKana,
            email: this.state.email,
            tel: this.state.tel,
            forecastValue: this.state.forecastValue,
            priceDisplay: this.state.priceDisplay,
            prevLoginId: this.state.prevLoginId
        }
    }

    sendMail = (sendMail) => {
        let businessPartner = this.setBusinessPartnerModel();

        businessPartner.sendMail = sendMail;

        if (sendMail) {
            this.setState({ sending: true })
        }
        this.props.addBusinessPartner(businessPartner).then((result) => {
            this.showError(result)
        });
    }

    registerOrder = () => {
        let businessPartner = this.setBusinessPartnerModel();
        this.props.addBusinessPartner(businessPartner).then((result) => {
            this.showError(result)
        });
    }

    showList = () => {
        this.props.history.push(BUSINESS_PARTNER);
    }

    delete = () => {
        this.setState({promptDelete:false})
        this.props.deleteBusinessPartner(
            { businessPartnerCode: this.props.credentials.riyo_kigyo_id, userCode: this.props.match.params.id },
            this.props.credentials.businessPartner_cd
        ).then((result) => {
            this.showError(result)
        }).catch(()=>this.setState({ error: [ERROR_BP_DELETE] }));
    }

    showError = (result) => {
        if (ERROR === result.status) {
            this.setState({ error: [result.message] });
        } else {
            this.showList();
        }
    }

    openModal = () => {
        this.setState({ openModal: !this.state.openModal });
    };

    promptButtons = () => {
        if (this.state.sending ) {
            return []
        } else {
            return [
                { label: KANA_YES, action: ()=>{this.sendMail(true)} },
                { label: KANA_NO, action: ()=>{this.sendMail(false)} }
            ]
        }
    }

    mailButtons = () => {
        let businessPartner = this.setBusinessPartnerModel();
        
        let href_link = "mailto:" + businessPartner.email
            + "?Subject=【ことねぎオーダーシステム】登録完了のお知らせ"
            + "&Body=" + businessPartner.businessPartnerName + "様%0A"
            + "%0A"
            + "ご利用ありがとうございます。%0A"
            + "登録完了のお知らせメールです。%0A"
            + "%0A"
            + "---------------------------%0A"
            + "ログインID:" + businessPartner.loginId + "%0A"
            + "パスワード:" + businessPartner.password + "%0A"
            + "---------------------------%0A"
            + "%0A"
            + "このメールはインターネット経由で送信しています。%0A"
            + "セキュリティ上、上記パスワードは変更されることをお勧めします。%0A"
            + "下記の「パスワード変更はこちら」で変更できます。%0A"
            + "%0A"
            + "■ことねぎオーダーシステム%0A"
            + "https://www.kotonegi.com/kotojuchu/%0A"
            + "%0A"
            + "こと京都株式会社"

        if (this.state.sending ) {
            return []
        } else {
            return [
                { text: KANA_YES, link: href_link, action: ()=>{this.registerOrder()} },
                { text: KANA_NO, link: "#", action: ()=>{this.registerOrder()} }
            ]
        }
    }

    formButtons() {  
        if (MODE_EDIT === this.state.mode && this.state.invalidShop) {
            return [
                { label: "戻る", onClick: () => this.showList() }
            ]
        }else if (this.props.credentials.user_cd.toString() === this.props.match.params.id
            || this.state.default) {
            return [
                { label: "登録", onClick: () => this.handleSubmit() },
                { label: "戻る", onClick: () => this.showList() }
            ]
        } else {
            return [
                { label: "登録", onClick: () => this.handleSubmit() },
                { label: "削除", conditional: true, onClick: () => this.setState({promptDelete:true}) },
                { label: "戻る", onClick: () => this.showList() }
            ]
        }
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"取引先編集"} />

                    <ErrorAlert errors={this.state.error} />

                        <FormTemplate
                            {...this.props}
                            {...this.state}
                            className="product-form"
                            horizontal={true}
                            editMode={MODE_EDIT === this.state.mode}
                            handleInputChange={this.handleInputChange}
                            handleSubmit={this.handleSubmit}
                            formButtons={this.formButtons()}
                            default={this.state.default}
                        />
                        
                    <Confirmation
                        message={CONFIRMATION_DELETE}
                        showConfirmation={this.state.promptDelete}
                        buttons={[
                            { label: KANA_YES, action: ()=>{this.delete()} },
                            { label: KANA_NO, action: ()=>{this.setState({promptDelete:false})} }
                        ]}
                    />
                    
                    <ConfirmationMail
                        message={"登録した取引先にメールで連絡しますか？"}
                        showConfirmation={this.state.openModal}
                        buttons={this.mailButtons()}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tableList: state.businessPartner.list,
        credentials: state.auth.credentials,
        formInputs: state.businessPartner.form,
        radioButtonInput: state.businessPartner.radioButtonInput
    }
};
const mapDispatchToProps = {
    view: businessPartnerOperations.viewBusinessPartner,
    addBusinessPartner: businessPartnerOperations.addBusinessPartner,
    editBusinessPartner: businessPartnerOperations.editBusinessPartner,
    deleteBusinessPartner: businessPartnerOperations.deleteBusinessPartner,
    checkLoginIdExists: businessPartnerOperations.checkLoginIdExists
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewBusinessPartner);